export const CardLabel = `Cartão de crédito`;
export const PaymentsWay = `Formas de pagamento`;